import { CONTENT_IMAGE_PATH } from '@shared/config/paths/paths';
import { ROUTES } from '@shared/constants/routes';

import { BlogPostType } from '../model/types/blog';

export const getBlogPostImageUrl = (image?: string) => {
  if (!image) {
    return '';
  }

  if (image.startsWith('/')) {
    return image;
  }

  if (image.startsWith('http')) {
    try {
      const url = new URL(image);
      return url.pathname.startsWith('/files') ? url.pathname : image;
    } catch {
      return image;
    }
  }

  return `${CONTENT_IMAGE_PATH}/${image}/original.png`;
};

export const getBlogPostDateValue = (post: BlogPostType) => post.publishedAt || post.createdAt || post.updatedAt || '';

export const formatBlogPostDate = (post: BlogPostType) => {
  const date = getBlogPostDateValue(post);

  if (!date) {
    return '';
  }

  return new Intl.DateTimeFormat('ru-RU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(new Date(date));
};

export const getBlogPostUrl = ({ slug, id }: BlogPostType) => `${ROUTES.BLOG}/${slug || id}`;
